module.exports = __webpack_public_path__ + "static/img/empty1.de6bfdd2.png";